class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.querySelector('[id^="ProductCount--"]');
    document.querySelector('[id^="ProductGridContainer--"]').querySelector('.collection').classList.add('loading');
    if (countContainer) countContainer.classList.add('loading');  

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    document.dispatchEvent(new CustomEvent('page:reloaded'));
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.querySelector('[id^="ProductGridContainer--"]').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('[id^="ProductGridContainer--"]').innerHTML;
    
    const layoutSwitcher = document.querySelector('#FacetFiltersForm layout-switcher');
    if (layoutSwitcher) layoutSwitcher.onButtonClick(layoutSwitcher.querySelector('.list-view__item--active'));
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').querySelector('[id^="ProductCount--"]').innerHTML
    const container = document.querySelector('[id^="ProductCount--"]');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersForm-2 .js-filter');

    const matchesId = (element) => { 
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false; 
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesId);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[id="${element.id}"]`).innerHTML = element.innerHTML;
    });
    document.dispatchEvent(new CustomEvent('filters:rerendered'));
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.querySelector(`[id="${closestJSFilterID}"]`));
      }
    }
  }

  static renderActiveFacets(html) {
    const isRTL = document.documentElement.dir === 'rtl';
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop', '.active-facets-desktop-2', '.active-facets--result', '.active-facets--result-2', '.results-toast--horizontal', '.results-toast--vertical', '.results-toast--drawer'];
    
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })
    
    if(window.innerWidth <= 768 || document.querySelector('.drawer-filter')) {    
      const resultsToast = document.querySelector('.results-toast--drawer')
      if(!resultsToast) return
      const positionRight = (resultsToast.closest('facet-filters-form').offsetWidth + 48) / 2
      resultsToast.style.insetInlineEnd = `${positionRight}px`
      resultsToast.style.transform = isRTL ? 'translate(-50%, -24px)' : 'translate(50%, -24px)'
      setTimeout(() => {
        resultsToast.style.transform = isRTL ? 'translate(-50%, 100px)'  : 'translate(50%, 100px)'
      }, 3000)
    }
    if(window.innerWidth > 768 && document.querySelector('.vertical-filter') || window.innerWidth > 768 && document.querySelector('.horizontal-filter')) {
      const resultsToast = document.querySelector('.results-toast--horizontal') || document.querySelector('.results-toast--vertical')
      if(!resultsToast) return
      resultsToast.style.insetInlineEnd = `50%`
      resultsToast.style.transform = isRTL ? 'translate(-50%, -24px)' : 'translate(50%, -24px)'
      setTimeout(() => {
        resultsToast.style.transform = isRTL ? 'translate(-50%, 100px)' : 'translate(50%, 100px)'
      }, 3000)
    }
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.facets__open', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');
    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.querySelector('[id^="product-grid--"]').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    try{iWish&&setTimeout(()=>iWish.checkIwishColl(),2000)}catch(e){} 
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    try{iWish&&setTimeout(()=>iWish.checkIwishColl(),2000)}catch(e){} 
    FacetFiltersForm.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      try{iWish&&setTimeout(()=>iWish.checkIwishColl(),2000)}catch(e){} 
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define('facet-remove', FacetRemove);